import user from '@/stores/user';
import { getContract } from '@/utils';
import { Contract } from 'ethers';
import { useCallback, useEffect, useState } from 'react';
import { useEthersProvider } from './useEthersProvider';

import { DefaultChainId } from '@/constant';
import { useAccount, useChainId } from 'wagmi';

export function useContract(
    address: string | undefined,
    ABI: any,
    withSignerIfPossible = true,
): Contract | null {
    const chainId = useChainId();
    const { address: account } = useAccount();
    const provider = useEthersProvider({
        chainId: chainId || DefaultChainId,
        account,
    });

    const [contract, setContract] = useState<Contract | null>(null);

    async function init() {
        if (!address || !ABI || !provider) return null;
        try {
            const contract = await getContract(
                address,
                ABI,
                provider as any,
                withSignerIfPossible && account ? account : undefined,
            );

            setContract(contract);
        } catch (error) {
            console.error('Failed to get contract', error);
            console.error(address);
            setContract(null);
        }
    }

    useEffect(() => {
        init();
    }, [address, ABI, provider, withSignerIfPossible, account]);

    return contract;
}

export function useGetContract() {
    const chainId = useChainId();
    const { address: account } = useAccount();
    const provider = useEthersProvider({
        chainId: chainId || DefaultChainId,
        account,
    });

    return useCallback(
        async (address: string, ABI: any) => {
            return await getContract(
                address,
                ABI,
                provider as any,
                account ? account : undefined,
            );
        },
        [provider, account],
    );
}
export function useGetContractByChainId() {
    const { address: account } = user;
    const chainId = useChainId();
    const { address } = useAccount();
    const provider = useEthersProvider({
        account: address,
        chainId: chainId || DefaultChainId,
    });
    return useCallback(
        async (address: string, ABI: any) => {
            if (!address || !ABI || !provider) return null;
            return await getContract(address, ABI, provider as any, account);
        },
        [account, provider],
    );
}
